import { fetchPeeps, selectPeep, updateFirestoreReview, updateReview } from './app.reactions'

export default [
  ['SELECT_PEEP', selectPeep],
  ['ADD_REVIEW', updateFirestoreReview],
  ['ADD_REVIEW', updateReview],
  ['SET_CENTER', fetchPeeps],
  ['SET_CENTER', (store) => selectPeep(store, { type: 'SET_CENTER' })],
]
